import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const BlogHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);

  const isActiveLink = (path) => {
    if (path === '/blog') {
      return location.pathname.startsWith('/blog');
    }
    return location.pathname === path;
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled
        ? 'bg-background-dark/95 backdrop-blur-md shadow-lg border-b border-accent/10'
        : 'bg-transparent'
    }`}>
      <div className={`absolute inset-0 pointer-events-none transition-all duration-300 ${
        scrolled
          ? 'bg-background-dark/95 backdrop-blur-md'
          : 'bg-gradient-to-b from-background-dark/80 via-background-dark/20 to-transparent'
      }`} />
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <Link to="/" className="flex items-center space-x-2 group">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-accent rounded-lg flex items-center justify-center text-background-dark font-bold text-sm sm:text-base group-hover:scale-105 transition-transform duration-300">
              AC
            </div>
            <span className="font-bold text-lg sm:text-xl text-slate-100 transition-colors duration-300">
              Andy Cary
            </span>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-sm font-medium text-slate-400 hover:text-accent transition-colors duration-300">
              Home
            </Link>
            <Link to="/about" className="text-sm font-medium text-slate-400 hover:text-accent transition-colors duration-300">
              About
            </Link>
            <Link to="/portfolio" className="text-sm font-medium text-slate-400 hover:text-accent transition-colors duration-300">
              Portfolio
            </Link>
            <Link
              to="/blog"
              className={`text-sm font-medium transition-colors duration-300 ${
                isActiveLink('/blog') ? 'text-accent' : 'text-slate-400 hover:text-accent'
              }`}
            >
              Blog
            </Link>
            <Link
              to="/contact"
              className="px-4 py-2 text-sm font-medium rounded-lg bg-accent text-background-dark hover:bg-accent/90 transition-all duration-300"
            >
              Contact
            </Link>
          </nav>

          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-lg border border-accent/20 text-slate-100 hover:bg-accent/10 transition-colors duration-300"
            aria-label="Toggle menu"
          >
            <div className="w-6 h-6 flex flex-col justify-center items-center">
              <span className={`block w-5 h-0.5 bg-current transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-1' : ''}`} />
              <span className={`block w-5 h-0.5 bg-current transition-all duration-300 mt-1 ${isOpen ? 'opacity-0' : ''}`} />
              <span className={`block w-5 h-0.5 bg-current transition-all duration-300 mt-1 ${isOpen ? '-rotate-45 -translate-y-1' : ''}`} />
            </div>
          </button>
        </div>

        <div className={`md:hidden transition-all duration-300 overflow-hidden ${isOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'}`}>
          <div className="py-4 space-y-2 border-t border-accent/10">
            <Link to="/" className="block px-4 py-2 text-sm font-medium text-slate-300 hover:text-accent hover:bg-accent/5 rounded-lg" onClick={() => setIsOpen(false)}>Home</Link>
            <Link to="/about" className="block px-4 py-2 text-sm font-medium text-slate-300 hover:text-accent hover:bg-accent/5 rounded-lg" onClick={() => setIsOpen(false)}>About</Link>
            <Link to="/portfolio" className="block px-4 py-2 text-sm font-medium text-slate-300 hover:text-accent hover:bg-accent/5 rounded-lg" onClick={() => setIsOpen(false)}>Portfolio</Link>
            <Link
              to="/blog"
              className={`block px-4 py-2 text-sm font-medium rounded-lg ${isActiveLink('/blog') ? 'text-accent bg-accent/10' : 'text-slate-300 hover:text-accent hover:bg-accent/5'}`}
              onClick={() => setIsOpen(false)}
            >
              Blog
            </Link>
            <Link to="/contact" className="block px-4 py-2 text-sm font-medium bg-accent text-background-dark rounded-lg hover:bg-accent/90" onClick={() => setIsOpen(false)}>Contact</Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default BlogHeader; 